"use client";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { useMemo } from "react";
import { z } from "zod";
import DynamicForm from "@/components/dynamicForm";

const CheckInForm = ({ onClose }) => {
  const t = useTranslationDetector("bus");

  const schema = useMemo(
    () =>
      z.object({
        ticketNumber: z
          .string()
          .trim()
          .min(1, t("checkInFormTicketNoRequired")),
        surname: z
          .string()
          .trim()
          .min(1, t("checkInFormSurnameRequired")),
      }),
    [t],
  );

  return (
    <div className="pb-8">

      <DynamicForm
        schema={schema}
        dryRun
        onSuccess={(data) => {
          onClose();
        }}
        defaultValues={{ ticketNumber: "", surname: "" }}
        className="space-y-4"
      >
        <DynamicForm.Field
          name="ticketNumber"
          type="text"
          placeholder={t("checkInFormTicketNo")}
        />

        <DynamicForm.Field
          name="surname"
          type="text"
          placeholder={t("checkInFormSurname")}
        />

        <div className="flex flex-col gap-2">
          <DynamicForm.Button className="flex-1 rounded bg-primary px-4 py-2 text-white hover:bg-primary/90">
            {t("checkInFormSubmit")}
          </DynamicForm.Button>

          <div className="mt-1 text-[16px] inline" style={{ color: "#585B5E" }}>
            {t("pnrFormHelpText")}{" "}
            <button
              type="button"
              className="text-[#01007F] underline p-0 m-0 bg-transparent border-0 cursor-pointer font-inherit text-[16px]"
              style={{ verticalAlign: "baseline", display: "contents" }}
              onClick={() => {
                // TODO: Yardım bağlantısı/aksiyonu
              }}
            >
              {t("pnrFormCantFindLink")}
            </button>
          </div>

        </div>
      </DynamicForm>
    </div>
  );
};

export default CheckInForm;
